import { Component, Input } from '@angular/core';

import { VtmnPlayButtonSizeEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-size.enum';
import { VtmnPlayButtonVariantEnum } from '~/component/buttons/vtmn-play-button/enum/vtmn-play-button-variant.enum';

@Component({
  selector: 'app-organizer-shared-edit-section',
  templateUrl: './edit-section.component.html',
})
export class OrganizerSharedEditSectionComponent {
  @Input() public link: string;
  @Input() public title: string;

  public readonly vtmnPlayButtonSize = VtmnPlayButtonSizeEnum;
  public readonly vtmnPlayButtonVariant = VtmnPlayButtonVariantEnum;
}
